<template>
    <div>
        <header class="header">
            <h1 class="header__site"><a href="/">åpenhet.no</a></h1>
            <div class="header__hamburger" v-bind:class="{ 'header__hamburger--open': menu }" v-on:click="menu = !menu">
                <span></span>
                <span></span>
                <span></span>
            </div>
            <nav class="header__nav" v-bind:class="{ 'header__nav--visible': menu }">
                <ul class="header__nav__menu">
                    <li><router-link to="/initiativer" href="">Initiativer</router-link></li>
                    <li><router-link to="/blogg">Blogg</router-link></li>
                    <li><router-link to="/sok">Søk</router-link></li>
                    <li class="header__nav__facebook">
                        <a href="https://www.facebook.com/%C3%85penhetno-107703601051770/">
                            <svg class="header__nav__facebook__icon">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-facebook"></use>
                            </svg>
                            <span>Facebook</span></a
                        >
                    </li>
                </ul>
                <p class="header__nav__about">En plattform som fremmer tiltak for større åpenhet i samfunnet.</p>
                <div class="header__nav__maillist" v-on:click="showSubscribe()">
                    <svg>
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-mail"></use>
                    </svg>
                    <h3>E-postliste</h3>
                    <p>Hold deg oppdatert på åpenhetstiltak.</p>
                </div>
                <router-link to="/blogg/har-du-en-id%C3%A9-til-et-tiltak-for-%C3%A5penhet-registrer-det-her" tag="div" class="header__nav__register">
                    <svg>
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-light-bulp"></use>
                    </svg>
                    <h3>Åpenhetstiltak</h3>
                    <p>Register gode tiltak her og spre informasjon.</p>
                </router-link>
            </nav>
        </header>
        <header class="header__hero header__hero--home" v-if="home">
            <h2 class="header__hero__heading">Åpenhetstiltak</h2>
            <div class="header__hero__intro">
                Samarbeidsplattform med nyheter, meninger og informasjon om viktige tiltak som fremmer større åpenhet i samfunnet.
            </div>
            <router-link to="/blogg/har-du-en-id%C3%A9-til-et-tiltak-for-%C3%A5penhet-registrer-det-her" tag="div" class="header__hero__c2a">
                <svg class="header__hero__c2a__icon">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-light-bulp"></use>
                </svg>
                <div class="header__hero__c2a__text">Har du en idé til et tiltak for åpenhet.<br />Register det her!</div>
            </router-link>
        </header>

        <header class="header__hero header__hero--blog" v-if="blog">
            <h2 class="header__hero__heading">Åpenhetsbloggen</h2>
            <div class="header__hero__intro">&ndash; nyheter, oppdateringer og meninger om viktige åpenhetstiltak.</div>
            <div class="header__hero__c2a" v-on:click="showSubscribe()">
                <svg class="header__hero__c2a__icon">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-mail"></use>
                </svg>
                <div class="header__hero__c2a__text">Meld deg på e-postlista og hold deg oppdatert på åpenhetstiltak!</div>
            </div>
        </header>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'Header',
    data: function () {
        return {
            menu: false,
            home: false,
            blog: false,
        };
    },
    methods: {
        ...mapActions(['showSubscribe']),
    },
    watch: {
        '$route.name': function (name) {
            this.menu = false;
            this.home = name == 'Home' || name == 'Articles';
            this.blog = name == 'Blog';
        },
    },
    created() {
        this.home = this.$route.name == 'Home' || name == 'Articles';
        this.blog = this.$route.name == 'Blog';
    },
};
</script>

<style lang="scss">
@import '@/styles/global';

body {
    padding-top: 70px;
}

.header {
    position: fixed;
    width: 100%;
    top: 0;
    height: 70px;
    z-index: 99;

    padding: 20px 25px 15px 25px;
    background-color: #a2bfdb;
    color: #fff;

    @include bp($laptop) {
        height: 80px;
    }

    &__site {
        position: relative;
        display: inline-block;
        margin-top: -5px;
        margin-bottom: 0;

        font-size: 39px;
        line-height: 1;

        a {
            color: inherit;
            text-decoration: none;

            &:hover {
                color: #fff;
            }
        }

        &:before {
            content: '';
            position: absolute;
            left: 0;
            bottom: 4px;
            height: 1px;
            width: 14px;
            background-color: #3c72bc;
        }

        &:after {
            content: '';
            position: absolute;
            right: 0;
            bottom: 4px;
            height: 1px;
            width: 138px;
            background-color: #3c72bc;
        }

        @include bp($laptop) {
            margin-top: -1px;
            font-size: 44px;

            &:after {
                width: 153px;
            }

            &:hover {
                &:before {
                    height: 2px;
                }
                &:after {
                    height: 2px;
                }
            }
        }
    }

    &__hamburger {
        position: absolute;
        top: 25px; //48px;
        right: 25px;
        width: 30px;
        height: 20px;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        span {
            width: 100%;
            height: 1px;
            background-color: #3c72bc;

            transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
        }

        &--open {
            justify-content: flex-start;
            span:nth-child(1) {
                margin-top: 9px;
                transform: rotate(45deg);
            }

            span:nth-child(2) {
                opacity: 0;
            }

            span:nth-child(3) {
                margin-top: -2px;
                transform: rotate(-45deg);
            }
        }

        @include bp($laptop) {
            display: none;
        }
    }

    &__nav {
        z-index: 1;
        display: flex;
        position: fixed;
        left: 0px;
        right: 0px;
        top: 60px;
        padding: 0 25px;

        flex-direction: row;
        flex-wrap: wrap;

        max-height: 0;
        overflow-y: hidden;

        transition: max-height 0.5s ease-in-out;

        background-color: #a2bfdb;

        @include bp($laptop) {
            max-height: none;
            top: -2px;
            left: auto;
            width: auto;
        }

        &--visible {
            display: flex;
            max-height: 300px;
        }

        &__menu {
            margin: 25px 0 25px 0;
            padding: 0;
            list-style-type: none;
            width: 100%;

            @include bp($laptop) {
                display: flex;
            }

            li {
                @include bp($laptop) {
                    margin-left: 30px;
                }

                a {
                    font-size: 18px;
                    color: #fff;

                    @include bp($laptop) {
                        font-size: 22px;
                        text-decoration: none;
                        &:hover {
                            text-decoration: underline;
                        }
                    }
                }
            }
        }

        &__facebook {
            position: absolute;
            right: 25px;
            top: 25px;
            width: 30px;
            height: 25px;

            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            border: 1px solid #3c72bc;

            @include bp($laptop) {
                position: relative;
                right: auto;
                top: 4px;
                width: 45px;
                height: 30px;
            }

            span {
                display: none;
            }

            svg {
                width: 12px;
                height: 12px;

                @include bp($laptop) {
                    width: 16px;
                    height: 16px;
                }
            }
        }

        &__about {
            width: 100%;
            padding: 0 7%;
            text-align: center;
            margin: 0 auto 30px 0;

            font-size: 17px;
            line-height: 1.2;

            @include bp($laptop) {
                display: none;
            }
        }

        &__maillist,
        &__register {
            width: 50%;
            padding: 0 5%;
            text-align: center;
            margin: 0 auto 25px 0;

            font-size: 17px;
            line-height: 1.2;

            @include bp($laptop) {
                display: none;
            }

            h3 {
                font-size: 16px;
            }

            p {
                font-size: 11px;
            }

            svg {
                width: 35px;
                height: 35px;
            }
        }

        &__maillist {
            padding-left: 20px;
            border-right: 1px solid #3c72bc;
        }

        &__register {
            padding-right: 20px;
        }
    }
}

.header__hero {
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: center;

    background-color: #a2bfdb;
    color: #fff;

    padding: 30px 0;

    &__heading {
        font-size: 39px;
        margin-bottom: 1px;

        @include bp($laptop) {
            font-size: 64px;
        }
    }

    &__intro {
        margin-bottom: 30px;
        font-size: 19px;
        line-height: 1.2;

        max-width: 70%;
        text-align: center;

        @include bp($laptop) {
            font-size: 30px;
            max-width: 820px;
        }
    }

    &__c2a {
        display: flex;
        flex-direction: column;
        align-items: center;

        cursor: pointer;

        @include bp($laptop) {
            position: absolute;
            right: 60px;
            bottom: 40px;
            width: 160px;
            padding-left: 20px;
            border-left: 1px solid #3c72bc;
        }

        &__icon {
            width: 30px;
            height: 30px;
            margin-bottom: 10px;
        }

        &__text {
            max-width: 240px;
            text-align: center;

            font-size: 15px;
            line-height: 1.5;

            @include bp($laptop) {
                font-size: 16px;
            }
        }
    }
}
</style>
